import { SET_DRAWER, SET_DRAWER_OPEN, SET_DRAWER_CLOSE, TOGGLE_DRAWER } from "../actions/drawerActions"

const initialState = {
  drawerVisible: false,
  drawerID: '',
}

function drawerReducer(state = initialState, action) {
  switch (action.type) {
  case SET_DRAWER:
    return {
      ...state,
      drawerID: action.payload.drawerID
    }
  case SET_DRAWER_OPEN:
    return {
      ...state,
      drawerVisible: true
    }
  case SET_DRAWER_CLOSE:
    return {
      ...state,
      drawerVisible: false
    }
  case TOGGLE_DRAWER:
    return {
      ...state,
      drawerVisible: !state.drawerVisible
    }
  default:
    return state;
  }
}

export default drawerReducer;